import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import NotificationItem from '../../molecules/NotificationItem';

const Title = styled.h3`
  margin-bottom: 10px;
`;

const ListWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  max-height: calc(100vh - 205px);
  overflow-y: auto;

  > div {
    margin-bottom: 10px;
  }
`;

function NotificationList({ onPreview, notificationList, onDelete, onRestore, loading }) {
  return (
    <>
      <Title>Lista de Notificações</Title>
      <ListWrapper>
        {notificationList.map((notification) => (
          <NotificationItem
            loading={loading}
            key={`notification-${notification.id}`}
            notification={notification}
            onPreview={onPreview}
            onDelete={onDelete}
            onRestore={onRestore}
          />
        ))}
      </ListWrapper>
    </>
  );
}

NotificationList.propTypes = {
  loading: PropTypes.bool.isRequired,
  onPreview: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  notificationList: PropTypes.array.isRequired,
};

export default NotificationList;
